import { referenceToOption as defaultReferenceToOption } from 'reference-resolvers-lite/utils/referenceToOption';
export const referenceToOptionWithReference = reference => Object.assign({}, defaultReferenceToOption(reference), {
  reference
});